import React from "react";

export function ViewersList({ show, viewers, backendUrl, profilePicture }) {
  const formatUsername = (name) => {
    return name.toLowerCase().replace(/\s+/g, "");
  };
  if (!show || viewers.length === 0) return null;
  return (
    <div className="absolute left-0 top-full mt-1 bg-white rounded-lg shadow-lg border border-gray-200 py-2 min-w-[200px] z-10">
      <div className="px-3 py-1 text-md text-gray-500 font-semibold border-b border-gray-100">
        Visto por
      </div>
      {viewers.map((viewer) => (
        <div
          key={viewer.id}
          className="px-3 py-2 hover:bg-gray-50 flex items-center gap-2 group relative cursor-default"
        >
          <div className="w-6 h-6 rounded-full overflow-hidden">
            <img
              src={
                viewer?.avatar?.url
                  ? `${backendUrl}${viewer?.avatar?.url}`
                  : profilePicture
              }
              alt={viewer.name}
              className="w-full h-full object-cover"
            />
          </div>
          <span className="text-md text-gray-700">
            @{formatUsername(viewer.username)}
          </span>
          <div className="absolute left-full ml-2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
            {viewer.username}
          </div>
        </div>
      ))}
    </div>
  );
}
